import {OrderInvoiceService} from "./OrderInvoiceService";
import {ApplicationService} from "@hec/models";

export const requiredOrderInvoiceServices = (): ApplicationService[] => {
  return [
    new OrderInvoiceService()
  ];
}
